import React, { useContext, FunctionComponent } from 'react';

import { DndProvider } from 'react-dnd'; // can remove or hoist with reactify asset modal project
import HTML5Backend from 'react-dnd-html5-backend'; // can remove or hoist with reactify asset modal project
import { Asset, LinkObject } from '@api/v4/assets/assetTypes';
import { FlattenedAttachment } from '../EditTabTypes';
import assetModalContext from '../asset_modal_context';
import AttachmentImage from './attachmentImage';
import AttachmentList from './attachmentList';
import AttachmentUploader from './attachmentUploader';

interface AttachmentListContainerScopedContext {
  state: {
    initialData: {
      asset: Asset;
      attachments: FlattenedAttachment[];
    };
    editState: {
      assetName: string;
      attachments: FlattenedAttachment[];
      thumbnailOverride: LinkObject;
      thumbnailUrl: string;
      watermark: LinkObject;
    };
  };
}

const AttachmentListContainer: FunctionComponent<{}> = () => {
  const { state }: AttachmentListContainerScopedContext = useContext(assetModalContext);
  const { assetName, attachments, thumbnailOverride, thumbnailUrl } = state.editState;

  return (
    <>
      <AttachmentImage
        assetName={assetName}
        attachmentCount={attachments.length}
        attachmentExtension={state.initialData.asset ? state.initialData.asset.extension : ''}
        src={thumbnailOverride?.url || thumbnailUrl}
      />
      <div className="attachment-list-title">
        <span className="bff-paperclip" />
        <h4 className="attachment-list-count">{attachments.length}</h4>
        <h4>{attachments.length !== 1 ? bfTranslate("Attachments") : bfTranslate("Attachment")}</h4>
      </div>
      <DndProvider backend={HTML5Backend}>
        <AttachmentList />
      </DndProvider>
      <AttachmentUploader />
    </>
  );
};

export default AttachmentListContainer;
